import { setStore, getStore } from '@/util/store'
import { diff } from '@/util/util'
import website from '@/util/website'
const isFirstPage = website.isFirstPage;
const tagWel = website.fistPage;
const tagObj = {
        label: '', //标题名称
        value: '', //标题的路径
        params: '', //标题的路径参数
        query: '', //标题的参数
        group: [], //分组
		moduleId: '',
		code: ''
    }
    //处理首个标签
function setFistTag(list) {
    if (list.length == 1) {
        list[0].close = false;
    } else {
        list.forEach(ele => {
            if (ele.value === tagWel.value && isFirstPage === false) {
                ele.close = false
            } else {
                ele.close = true
            }
        })
    }
}


const navs = {
    state: {
        tagList: getStore({ name: 'tagList' }) || [],
        tag: getStore({ name: 'tag' }) || tagObj,
        tagWel: tagWel,
		trClose: {
			cur: false,
			path: null
		}
    },
    actions: {
		/**
		 * 删除当前的TAG
		 */
		delCurrentTag({
			commit,
			state
		}, context_) {
			commit('DEL_CURRENT', context_);
		},
    },
    mutations: {
        ADD_TAG: (state, action) => {
            state.tag = action;
            setStore({ name: 'tag', content: state.tag, type: 'session' })
            if (state.tagList.some(ele => diff(ele, action))) return
            state.tagList.push(action)
            setFistTag(state.tagList);
            setStore({ name: 'tagList', content: state.tagList, type: 'session' })
        },
        DEL_TAG: (state, action) => {
			// debugger
            state.tagList = state.tagList.filter(item => {
                return !diff(item, action);
            })
            setFistTag(state.tagList);
            setStore({ name: 'tagList', content: state.tagList, type: 'session' })
        },
        DEL_ALL_TAG: (state) => {
			let tagLength = state.tagList.length;
			state.tagList.splice(1, tagLength - 1);
            //state.tagList = [state.tagWel];
            setStore({ name: 'tagList', content: state.tagList, type: 'session' })
        },
        DEL_TAG_OTHER: (state) => {
            state.tagList = state.tagList.filter(item => item.value === state.tag.value)
            setFistTag(state.tagList);
            setStore({ name: 'tagList', content: state.tagList, type: 'session' })
        },
		DEL_CURRENT: (state, action) => {
			state.trClose.cur = action.cur;
			state.trClose.path = action.path;
        }
    }
}
export default navs


// WEBPACK FOOTER //
// ./src/vuex/modules/tags.js